import { useCallback } from 'react';

import AppRoute from 'App/PrivateRoute';
import { useInventoryModuleAccess } from 'hooks/inventories/useInventoryModuleAccess';
import { RemoteInventoryApp } from 'mfe/remotes/inventory';
import { withRequiredLicense } from 'providers/root/AuthProvider';

// Same subscription redirect the legacy module applies, so an unpaid organization lands on /subscriptions.
const LicensedRemoteInventoryApp = withRequiredLicense()(RemoteInventoryApp);

/**
 * Inventories module served by the `parrot-inventory-web` microfrontend
 * (runtime Module Federation remote), for organizations migrated to V2.
 * Uses the same feature, license and subscription gating as the legacy module so access rules do not change.
 */
export const InventoriesRemoteRoutes = () => {
  const { hasModuleAccess } = useInventoryModuleAccess();

  // El remote **falla cerrado** si no recibe `hasModuleAccess`: montarlo no es
  // permiso. Se le pasa la MISMA barrera que decide si la ruta se puede abrir,
  // que es donde el host ya la tiene resuelta.
  const Inventories = useCallback(() => <LicensedRemoteInventoryApp hasModuleAccess={hasModuleAccess} />, [
    hasModuleAccess,
  ]);

  return <AppRoute accessRoute={hasModuleAccess} component={Inventories} path="/inventories" />;
};
